import { render, staticRenderFns } from "./TimsDatepicker.vue?vue&type=template&id=f8f291b2&scoped=true&"
import script from "./TimsDatepicker.vue?vue&type=script&lang=ts&"
export * from "./TimsDatepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f291b2",
  null
  
)

export default component.exports